<template>
  <el-menu-item style="float:right;font-family: Verdana;font-size: 10pt; padding-right: 5px;position: relative;top: -2px;">
      <el-button size="mini" @click="loginMan" type="primary" class="pt-1 pb-1 m-0">
        Recharge $
      </el-button>
    <a v-if="userVOSBalance" class="ml-2">
      <div class="text-dark d-inline-block">
        Balance ${{ parseFloat(userVOSBalance).toFixed(2) }}
      </div>
    </a>
    <a v-if="userVOSOverdraft" class="ml-2">
      <span class="text-dark">
      Overdraft ${{ parseFloat(userVOSOverdraft).toFixed(2) }}
      </span>
    </a>
    <a v-if="userVOSOverdraft" class="ml-2">
      <span class="text-dark">
      Consumption ${{  parseFloat(todayconsumption).toFixed(2) }}
      </span>
    </a>
    <el-dialog :visible.sync="vosDialogVisibility" title="Use the below credentials to login" top="5vh" width="500px">
      <div class="ml-3 mr-2">
        <div class="m-0 font-we" style="line-height: 10px">
          <span class="field-mark-required"></span>
          Username: <span class="ml-1 mr-2 font-weight-bold d-inline-block"> {{ customerData.vos_username }} </span>
          <span class="ml-3 field-mark-required"></span>
          <span class="ml-2">Password:</span> <span
            class="ml-1 font-weight-bold d-inline-block"> {{ customerData.vos_password }} </span>
        </div>

        <a :href="customerData.vos_recharge_link" class="btn btn-info btn-sm mt-3 mb-0" target="_blank">
          Recharge Page
        </a>
        <small class="d-block font-italic text-lowercase" style="line-height: 30px;">
          Click the above  button to open the recharge page in a new window
        </small>
        <!-- <iframe class="mt-1 mb-5" referrerpolicy="origin" scrolling="yes" width="100%" height="600" :src="iframeSrc"></iframe>-->
      </div>
    </el-dialog>
  </el-menu-item>
</template>

<script>


export default {
  props: {
    userVOSBalance: {
      required: false,
      default: false
    },
    userVOSOverdraft: {
      required: false,
      default: false
    },
    todayconsumption: {
      required: false,
      default: "N/A"
    }
  },
  data() {
    return {
      customerData: {},
      userId: $store.state['user-state'].profile.id,
      vosLink: null,
      vosDialogVisibility: false,
    }
  },
  mounted() {
    this.getCustomerFields({id: this.userId}).then((r) => {
      this.customerData = r
      this.iframeSrc = this.customerData.vos_recharge_link + '/login?username=' + this.customerData.vos_username + '&password=' + this.customerData.vos_password
    })
  },
  methods: {
    loginMan() {
      this.vosDialogVisibility = true
    },
    ...$mapActions('user-customer-features-api', {
      getCustomerFields: 'get',
      loginToVos: 'loginToVos',
    }),
  }
}
</script>
